import { createGlobalStyle } from "styled-components";

import getImageUrl from "utils/getImageUrl";

const CzStyle = createGlobalStyle`
@font-face {
  font-display: block;
  font-family: "ThemeFontLight";
  src: url(${getImageUrl("/fonts/CZ/light/Vodafone_Lt.ttf?#iefix")});
  src: url(${getImageUrl("/fonts/CZ/light/Vodafone_Lt.ttf?#iefix")}) format("embedded-opentype"), 
       url(${getImageUrl("/fonts/CZ/light/Vodafone_Lt.ttf")}) format("woff"), 
       url(${getImageUrl("/fonts/CZ/light/Vodafone_Lt.ttf")}) format("truetype"), 
       url(${getImageUrl("/fonts/VodafoneLt-full.svg#VodafoneLt")}) format("svg");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-display: block;
  font-family: "ThemeFontRegular";
  src: url(${getImageUrl("/fonts/CZ/regular/Vodafone_Rg.ttf?#iefix")});
  src: url(${getImageUrl("/fonts/CZ/regular/Vodafone_Rg.ttf?#iefix")}) format("embedded-opentype"), 
       url(${getImageUrl("/fonts/CZ/regular/Vodafone_Rg.ttf")}) format("woff"), 
       url(${getImageUrl("/fonts/CZ/regular/Vodafone_Rg.ttf")}) format("truetype"), 
       url(${getImageUrl("/fonts/VodafoneRg.svg#VodafoneLt")}) format("svg");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-display: block;
  font-family: "ThemeFontBold";
  src: url(${getImageUrl("/fonts/CZ/bold/Vodafone_Bd.ttf?#iefix")});
  src: url(${getImageUrl("/fonts/CZ/bold/Vodafone_Bd.ttf?#iefix")}) format("embedded-opentype"), 
       url(${getImageUrl("/fonts/CZ/bold/Vodafone_Bd.ttf")}) format("woff"), 
       url(${getImageUrl("/fonts/CZ/bold/Vodafone_Bd.ttf")}) format("truetype"), 
       url(${getImageUrl("/fonts/VodafoneRgBold-full.svg#VodafoneRgBold")}) format("svg");
  font-weight: normal;
  font-style: normal;
}
  body {
    margin: 0;
    padding: 0;
    font-family: ThemeFontRegular, Open-Sans, Helvetica, Sans-Serif;
    background: #fff;
  }
  *{
    box-sizing:border-box;
  }

  input[type=checkbox] {
    width: 18px;
    height: 18px;
    accent-color: #111111;
    mix-blend-mode: multiply;
  }
`;

export default CzStyle;
